import React from 'react'
import { Button , Modal} from 'react-bootstrap';

const CancelUserOrder = (props) => {

  return (
    <>
      <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header className="red" closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Cancel order
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span>Are you sure you want to cancel your order?</span>
      </Modal.Body>
      <Modal.Footer>
        <Button className="button red" variant="primary" type="button">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  )
}

export default CancelUserOrder